export default "__VITE_ASSET__C8acX4PH__"